import { Component } from '@angular/core';

@Component({
  selector: 'app-abbreviation',
  template: `
  <div id="abbreviations">
  <table width="95%" border="0" cellpadding="5" cellspacing="0">
    <tr>
      <th align="left">Abbreviation</th>
      <th align="left">Full Name</th>
    </tr>
    <tr>
      <td>AEC</td>
      <td>Atomic Energy Commission</td>
    </tr>
    <tr>
      <td>AOC</td>
      <td>Area of Concern</td>
    </tr>
    <tr>
      <td>Apex</td>
      <td>Apex Environmental, Inc.</td>
    </tr>
    <tr>
      <td>AR</td>
      <td>Administrative Record</td>
    </tr>
    <tr>
      <td>ARAR</td>
      <td>Applicable or Relevant and Appropriate Requirements</td>
    </tr>
    <tr>
      <td>ARS</td>
      <td>Agricultural Research Service</td>
    </tr>
    <tr>
      <td>ATSDR</td>
      <td>Agency for Toxic Substances and Disease Registry</td>
    </tr>
    <tr>
      <td>AWQC</td>
      <td>Ambient Water Quality Criteria</td>
    </tr>
    <tr>
      <td>BARC</td>
      <td>Beltsville Agricultural Research Center</td>
    </tr>
    <tr>
      <td>BDRLF</td>
      <td>Beaver Dam Road Landfill</td>
    </tr>
    <tr>
      <td>BERA</td>
      <td>Baseline Ecological Risk Assessment</td>
    </tr>
    <tr>
      <td>bgs</td>
      <td>below ground surface</td>
    </tr>
    <tr>
      <td>BHNRC</td>
      <td>Beltsville Human Nutrition Research Center</td>
    </tr>
    <tr>
      <td>BRA</td>
      <td>Baseline Risk Assessment</td>
    </tr>
    <tr>
      <td>BTAG</td>
      <td>U.S. EPA Biological Technical Assistance Group</td>
    </tr>
    <tr>
      <td>CDP</td>
      <td>Chemical Disposal Pits</td>
    </tr>
    <tr>
      <td>CDR</td>
      <td>Covenant Deferral Request</td>
    </tr>
    <tr>
      <td>CERCLA</td>
      <td>Comprehensive Environmental Response, Compensation, and Liability Act of 1980</td>
    </tr>
    <tr>
      <td>CFR</td>
      <td>Code of Federal Regulations</td>
    </tr>
    <tr>
      <td>CMOE</td>
      <td>Canadian Ministry of the Environment</td>
    </tr>
    <tr>
      <td>COC</td>
      <td>Contaminant of Concern</td>
    </tr>
    <tr>
      <td>COPC</td>
      <td>Contaminant of Potential Concern</td>
    </tr>
    <tr>
      <td>CPLF</td>
      <td>College Park Landfill</td>
    </tr>
    <tr>
      <td>CRP</td>
      <td>Community Relations Plan</td>
    </tr>
    <tr>
      <td>CVM</td>
      <td>Center for Veterinary Medicine</td>
    </tr>
    <tr>
      <td>DAF20</td>
      <td>Dilution Attenuation Factor of 20</td>
    </tr>
    <tr>
      <td>DCA</td>
      <td>Dichloroethane</td>
    </tr>
    <tr>
      <td>DCE</td>
      <td>Dichloroethene</td>
    </tr>
    <tr>
      <td>DDD</td>
      <td>Dichlorodiphenyldichloroethane</td>
    </tr>
    <tr>
      <td>DDE</td>
      <td>Dichlorodiphenyltrichloroethylene</td>
    </tr>
    <tr>
      <td>DDT</td>
      <td>Dichlorodiphenyltrichloromethane</td>
    </tr>
    <tr>
      <td>DDX</td>
      <td>DDD, DDE, and/or DDT</td>
    </tr>
    <tr>
      <td>DOD</td>
      <td>U.S. Department of Defense</td>
    </tr>
    <tr>
      <td>DOI</td>
      <td>U.S. Department of the Interior</td>
    </tr>
    <tr>
      <td>DOJ</td>
      <td>U.S. Department of Justice</td>
    </tr>
    <tr>
      <td>DP</td>
      <td>Decommissioning Plan</td>
    </tr>
    <tr>
      <td>DRC</td>
      <td>Dispute Resolution Committee</td>
    </tr>
    <tr>
      <td>DQO</td>
      <td>Data Quality Objectives</td>
    </tr>
    <tr>
      <td>EE/CA</td>
      <td>Engineering Evaluation/Cost Analysis</td>
    </tr>
    <tr>
      <td>ENTECH</td>
      <td>ENTECH, Inc.</td>
    </tr>
    <tr>
      <td>EPA</td>
      <td>U.S. Environmental Protection Agency</td>
    </tr>
    <tr>
      <td>EPIC</td>
      <td>U.S. EPA Environmental Photographic Interpretation Center</td>
    </tr>
    <tr>
      <td>ERA</td>
      <td>Ecological Risk Assessment</td>
    </tr>
    <tr>
      <td>ESA</td>
      <td>Environmental Site Assessment</td>
    </tr>
    <tr>
      <td>FDA</td>
      <td>U.S. Food and Drug Administration</td>
    </tr>
    <tr>
      <td>FFA</td>
      <td>Federal Facilities Agreement</td>
    </tr>
    <tr>
      <td>FIT</td>
      <td>Field Investigation Team</td>
    </tr>
    <tr>
      <td>FS</td>
      <td>Feasibility Study</td>
    </tr>
    <tr>
      <td>FY</td>
      <td>Fiscal Year</td>
    </tr>
    <tr>
      <td>GC</td>
      <td>Gas Chromatography</td>
    </tr>
    <tr>
      <td>GPS</td>
      <td>Global Positioning System</td>
    </tr>
    <tr>
      <td>HASP</td>
      <td>Health and Safety Plan</td>
    </tr>
    <tr>
      <td>HHRA</td>
      <td>Human Health Risk Assessment</td>
    </tr>
    <tr>
      <td>HRS</td>
      <td>Hazard Ranking System</td>
    </tr>
    <tr>
      <td>IAG</td>
      <td>Interagency Agreement</td>
    </tr>
    <tr>
      <td>IDW</td>
      <td>Investigation-Derived Waste</td>
    </tr>
    <tr>
      <td>IR</td>
      <td>Information Repository</td>
    </tr>
    <tr>
      <td>KCI</td>
      <td>Kidde Consultants, Inc.</td>
    </tr>
    <tr>
      <td>LLRBS</td>
      <td>Low-Level Radiation Burial Site</td>
    </tr>
    <tr>
      <td>LLRW</td>
      <td>Low-Level Radioactive Waste</td>
    </tr>
    <tr>
      <td>MCL</td>
      <td>Maximum Contaminant Level</td>
    </tr>
    <tr>
      <td>MDE</td>
      <td>Maryland Department of the Environment</td>
    </tr>
    <tr>
      <td>MGD</td>
      <td>Million Gallons per Day</td>
    </tr>
    <tr>
      <td>mg/L</td>
      <td>Milligrams per Liter</td>
    </tr>
    <tr>
      <td>μg/kg</td>
      <td>Micrograms per Kilogram</td>
    </tr>
    <tr>
      <td>μg/L</td>
      <td>Micrograms per Liter</td>
    </tr>
    <tr>
      <td>MSL</td>
      <td>Mean Sea Level</td>
    </tr>
    <tr>
      <td>NASA</td>
      <td>National Aeronautics and Space Administration</td>
    </tr>
    <tr>
      <td>NCP</td>
      <td>National Oil and Hazardous Substances Pollution Contingency Plan</td>
    </tr>
    <tr>
      <td>NFA</td>
      <td>No Further Action</td>
    </tr>
    <tr>
      <td>NPL</td>
      <td>National Priorities List</td>
    </tr>
    <tr>
      <td>NRC</td>
      <td>Nuclear Regulatory Commission</td>
    </tr>
    <tr>
      <td>NTCRA</td>
      <td>Non-Time Critical Removal Action</td>
    </tr>
    <tr>
      <td>OC</td>
      <td>Organochlorine Pesticides</td>
    </tr>
    <tr>
      <td>ORNL</td>
      <td>Oak Ridge National Laboratory</td>
    </tr>
    <tr>
      <td>OSC</td>
      <td>On-Scene Coordinator</td>
    </tr>
    <tr>
      <td>OSHA</td>
      <td>Occupational Safety and Health Administration</td>
    </tr>
    <tr>
      <td>OSWER</td>
      <td>U.S. EPA Office of Solid Waste and Emergency Response</td>
    </tr>
    <tr>
      <td>OU</td>
      <td>Operable Unit</td>
    </tr>
    <tr>
      <td>PA</td>
      <td>Preliminary Assessment</td>
    </tr>
    <tr>
      <td>PAH</td>
      <td>Polynuclear Aromatic Hydrocarbon</td>
    </tr>
    <tr>
      <td>PA/SI</td>
      <td>Preliminary Assessment/Site Inspection</td>
    </tr>
    <tr>
      <td>PCB</td>
      <td>Polychlorinated Biphenyl</td>
    </tr>
    <tr>
      <td>PCE</td>
      <td>Tetrachloroethylene</td>
    </tr>
    <tr>
      <td>PCP</td>
      <td>Pentachlorophenol</td>
    </tr>
    <tr>
      <td>PDS</td>
      <td>Passive Diffusion Sampler</td>
    </tr>
    <tr>
      <td>PP</td>
      <td>Proposed Plan</td>
    </tr>
    <tr>
      <td>ppb</td>
      <td>parts per billion</td>
    </tr>
    <tr>
      <td>ppm</td>
      <td>parts per million</td>
    </tr>
    <tr>
      <td>PRAP</td>
      <td>Proposed Remedial (or Removal) Action Plan</td>
    </tr>
    <tr>
      <td>PRP</td>
      <td>Potentially Responsible Party</td>
    </tr>
    <tr>
      <td>QAPP</td>
      <td>Quality Assurance Project Plan</td>
    </tr>
    <tr>
      <td>QA/QC</td>
      <td>Quality Assurance/Quality Control</td>
    </tr>
    <tr>
      <td>RA</td>
      <td>Remedial Action</td>
    </tr>
    <tr>
      <td>RACT</td>
      <td>Reasonably Achievable Control Technology</td>
    </tr>
    <tr>
      <td>RAGS</td>
      <td>Risk Assessment Guidance for Superfund</td>
    </tr>
    <tr>
      <td>RAO</td>
      <td>Remedial Action Objectives</td>
    </tr>
    <tr>
      <td>RAP</td>
      <td>Risk Assessment Plan (or Remedial or Removal Plan)</td>
    </tr>
    <tr>
      <td>RAWP</td>
      <td>Removal Action Work Plan</td>
    </tr>
    <tr>
      <td>RBC</td>
      <td>Risk Based Concentration</td>
    </tr>
    <tr>
      <td>RBCL</td>
      <td>Risk-Based Cleanup Level</td>
    </tr>
    <tr>
      <td>RCRA</td>
      <td>Resource Conservation and Recovery Act</td>
    </tr>
    <tr>
      <td>RD</td>
      <td>Remedial Design</td>
    </tr>
    <tr>
      <td>RESRAD</td>
      <td>Residual Radioactivity</td>
    </tr>
    <tr>
      <td>RG</td>
      <td>Remedial Goals</td>
    </tr>
    <tr>
      <td>RI</td>
      <td>Remedial Investigation</td>
    </tr>
    <tr>
      <td>RI/FS</td>
      <td>Remedial Investigation/Feasibility Study</td>
    </tr>
    <tr>
      <td>ROD</td>
      <td>Record of Decision</td>
    </tr>
    <tr>
      <td>RPM</td>
      <td>Remedial Project Manager</td>
    </tr>
    <tr>
      <td>RSS</td>
      <td>Radiation Safety Staff</td>
    </tr>
    <tr>
      <td>SCS</td>
      <td>Soil Conservation Service</td>
    </tr>
    <tr>
      <td>SDWA</td>
      <td>Safe Drinking Water Act</td>
    </tr>
    <tr>
      <td>SEC</td>
      <td>Senior Executive Committee</td>
    </tr>
    <tr>
      <td>SERA</td>
      <td>Screening Ecological Risk Assessment</td>
    </tr>
    <tr>
      <td>SES</td>
      <td>Senior Executive Service</td>
    </tr>
    <tr>
      <td>SI</td>
      <td>Site Inspection</td>
    </tr>
    <tr>
      <td>SMDP</td>
      <td>Site Management Decision Point</td>
    </tr>
    <tr>
      <td>SMP</td>
      <td>Site Management Plan</td>
    </tr>
    <tr>
      <td>SOHES</td>
      <td>USDA Safety, Occupational Health, and Environmental Section</td>
    </tr>
    <tr>
      <td>SOP</td>
      <td>Standard Operating Procedure</td>
    </tr>
    <tr>
      <td>SSL</td>
      <td>Soil Screening Level</td>
    </tr>
    <tr>
      <td>SSP</td>
      <td>Site Screening Process</td>
    </tr>
    <tr>
      <td>SSWP</td>
      <td>Site-Specific Work Plan</td>
    </tr>
    <tr>
      <td>SVOC</td>
      <td>Semi-Volatile Organic Compound</td>
    </tr>
    <tr>
      <td>TAL</td>
      <td>Target Analyte List</td>
    </tr>
    <tr>
      <td>TAT</td>
      <td>U.S. EPA Technical Assistance Team</td>
    </tr>
    <tr>
      <td>TBD</td>
      <td>To Be Determined</td>
    </tr>
    <tr>
      <td>TCE</td>
      <td>Trichloroethylene</td>
    </tr>
    <tr>
      <td>TCL</td>
      <td>Target Compound List</td>
    </tr>
    <tr>
      <td>TCLP</td>
      <td>Toxicity Characteristic Leaching Procedure</td>
    </tr>
    <tr>
      <td>TCRA</td>
      <td>Time Critical Removal Action</td>
    </tr>
    <tr>
      <td>TM</td>
      <td>Technical Memoranda</td>
    </tr>
    <tr>
      <td>TPCP</td>
      <td>Test Pit Characterization Plan</td>
    </tr>
    <tr>
      <td>TSCA</td>
      <td>Toxic Substances Control Act</td>
    </tr>
    <tr>
      <td>USDA</td>
      <td>U.S. Department of Agriculture</td>
    </tr>
    <tr>
      <td>USFWS</td>
      <td>U.S. Fish and Wildlife Service</td>
    </tr>
    <tr>
      <td>USGS</td>
      <td>U.S. Geological Survey</td>
    </tr>
    <tr>
      <td>UST</td>
      <td>Underground Storage Tank</td>
    </tr>
    <tr>
      <td>VCP</td>
      <td>Voluntary Cleanup Program</td>
    </tr>
    <tr>
      <td>VOC</td>
      <td>Volatile Organic Compound</td>
    </tr>
    <tr>
      <td>WMATA</td>
      <td>Washington Metropolitan Area Transit Authority</td>
    </tr>
    <tr>
      <td>WSSC</td>
      <td>Washington Suburban Sanitary Commission</td>
    </tr>
  </table>
  </div>
  `
})
export class AbbreviationComponent { }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/abbreviation.ts